"use client";

import './accordion-item.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { Line, AccordionItem as AccordionItem$1 } from '@vds/core';
import Text from '../../typography/text/index.js';
import styles from './accordion-item.module.scss.js';

const AccordionItem = (props) => {
    const { size = 'large', header, viewport, padding, surface, fullBleedBackgroundColor, bottomLine = true, activeAccordionID, accordionItemId, onClick, behavior, alwaysOpen, inset, childrenInset, fullBleed, contentWidth, readonly = false, topLine = false } = props, rest = __rest(props, ["size", "header", "viewport", "padding", "surface", "fullBleedBackgroundColor", "bottomLine", "activeAccordionID", "accordionItemId", "onClick", "behavior", "alwaysOpen", "inset", "childrenInset", "fullBleed", "contentWidth", "readonly", "topLine"]);
    const titleWrapperStyles = [styles.titleWrapper];
    const accordionItemStyles = [styles.itemWrapper];
    const lineStyles = [styles.line];
    const surfaceColor = surface === null || surface === void 0 ? void 0 : surface.toLowerCase();
    if (padding === 'compact') {
        titleWrapperStyles.push(styles.compact);
    }
    if (padding === 'comfortable')
        accordionItemStyles.push(styles.comfortable);
    if (fullBleedBackgroundColor === 'stone' && fullBleed)
        accordionItemStyles.push(styles.stone);
    if (fullBleed) {
        accordionItemStyles.push(styles.fullBleed);
        lineStyles.push(styles.fullBleed);
    }
    if (readonly)
        accordionItemStyles.push(styles.readonly);
    if (size !== 'large')
        accordionItemStyles.push(styles.notLarge);
    const [hasBottomLine, setHasBottomLine] = useState(true);
    useEffect(() => {
        if (fullBleedBackgroundColor === 'stone') {
            if (behavior === 'singleOpen' && alwaysOpen) {
                setHasBottomLine(false);
            }
            if (!alwaysOpen &&
                behavior === 'singleOpen' &&
                activeAccordionID !== accordionItemId) {
                setHasBottomLine(true);
            }
        }
    }, [activeAccordionID, alwaysOpen]);
    const _onClick = () => {
        if (onClick)
            onClick(accordionItemId);
        if (fullBleedBackgroundColor === 'stone' && !alwaysOpen) {
            setHasBottomLine(!hasBottomLine);
        }
    };
    const getTextSize = () => {
        switch (size) {
            case 'small':
                return 'medium';
            case 'medium':
                return 'large';
            case 'large':
            default:
                return viewport === 'mobile' ? '2xsmall' : 'xsmall';
        }
    };
    const getViewportOverride = () => {
        if (rest.triggerElement === 'icon') {
            switch (size) {
                case 'small':
                case 'medium':
                    return 'mobile';
                case 'large':
                default:
                    return viewport;
            }
        }
        switch (size) {
            case 'small':
                return 'mobile';
            case 'medium':
            case 'large':
            default:
                return viewport;
        }
    };
    const _renderCustomHeader = () => (jsxs("div", { className: styles.headerWrapper, children: [jsxs("div", { className: titleWrapperStyles.join(' '), children: [(header === null || header === void 0 ? void 0 : header.eyebrow) && (jsx(Text, Object.assign({ kind: "body", size: size === 'large' && viewport !== 'mobile' ? 'large' : 'small', color: `var(--vds-color-element-secondary-on${surfaceColor})` }, header.eyebrow))), (header === null || header === void 0 ? void 0 : header.title) && (jsx(Text, Object.assign({ color: `var(--vds-color-element-primary-on${surfaceColor})` }, header === null || header === void 0 ? void 0 : header.title, { kind: size === 'large' ? 'title' : 'body', size: getTextSize() })))] }), (header === null || header === void 0 ? void 0 : header.subtitle) && (jsx(Text, Object.assign({ size: viewport === 'mobile' || size !== 'large' ? 'small' : 'large', kind: "body", color: `var(--vds-color-element-secondary-on${surfaceColor})` }, header === null || header === void 0 ? void 0 : header.subtitle)))] }));
    return (jsxs(Fragment, { children: [jsx("div", { className: lineStyles.join(' '), style: {
                    '--inset-value': inset,
                    '--line-max-width': contentWidth,
                }, children: jsx(Line, { surface: surface, color: topLine ? 'subtle' : 'transparent' }) }), jsxs("div", { className: accordionItemStyles.join(' '), style: {
                    '--inset-value': inset,
                    '--children-inset-value': childrenInset,
                    '--content-width': contentWidth,
                    '--details-margin': fullBleed ? '0 auto' : undefined,
                    '--details-max-width': fullBleed ? '1232px' : undefined,
                }, children: [jsx(AccordionItem$1, Object.assign({ onClick: _onClick, viewport: getViewportOverride(), surface: surface, behavior: behavior, alwaysOpen: alwaysOpen }, rest, { accordionItemId: accordionItemId, activeAccordionID: activeAccordionID, header: _renderCustomHeader(), padding: padding === 'comfortable' ? 'standard' : padding })), jsx("div", { className: lineStyles.join(' '), style: {
                            '--inset-value': inset,
                            '--line-max-width': contentWidth,
                        }, children: jsx(Line, { surface: surface, color: (fullBleedBackgroundColor === 'stone' &&
                                !hasBottomLine &&
                                fullBleed) ||
                                !bottomLine
                                ? 'transparent'
                                : 'subtle' }) })] })] }));
};
AccordionItem.componentType = 'AccordionItem';

export { AccordionItem as default };
